import { render, staticRenderFns } from "./AnnualReturnsTaskQueue.vue?vue&type=template&id=568f9418&scoped=true&"
import script from "./AnnualReturnsTaskQueue.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsTaskQueue.vue?vue&type=style&index=0&id=568f9418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f9418",
  null
  
)

export default component.exports